import { isInternalTraffic } from './internal-traffic';

let ga4Loaded = false;
let skimlinksLoaded = false;

/** Inject GA4 script and initialise dataLayer. Idempotent. */
export function loadGA4(measurementId: string): void {
  if (ga4Loaded || !measurementId) return;
  ga4Loaded = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);

  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).gtag = function () {
    (window as any).dataLayer.push(arguments);
  };
  (window as any).gtag('js', new Date());
  // A config parameter rides on every event this tag sends, the automatic
  // page_view included, which is what GA4's internal traffic filter reads.
  // Decided here rather than at boot so it only ever reaches a GA4 that
  // consent has already allowed to load.
  if (isInternalTraffic()) {
    (window as any).gtag('config', measurementId, { traffic_type: 'internal' });
  } else {
    (window as any).gtag('config', measurementId);
  }
}

/** Inject the official Skimlinks JS script. Idempotent. */
export function loadSkimlinksJS(publisherId: string): void {
  if (skimlinksLoaded || !publisherId) return;
  skimlinksLoaded = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://s.skimresources.com/js/${encodeURIComponent(publisherId)}.skimlinks.js`;
  document.head.appendChild(script);
}

export function loadGA4IfConfigured(): void {
  const ga4Id = import.meta.env.VITE_GA4_MEASUREMENT_ID;
  if (ga4Id) loadGA4(ga4Id);
}

export function loadSkimlinksIfConfigured(): void {
  const skimId = import.meta.env.VITE_SKIMLINKS_SITE_ID;
  if (skimId) loadSkimlinksJS(skimId);
}
